const stylesColors = require('./js/stylesColors');
const stylesTypography = require('./js/stylesTypography');

/* eslint-disable object-shorthand */
module.exports = {
  stylesColors: stylesColors,
  stylesTypography: stylesTypography
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-styles/index.js
// module id = 38
// module chunks = 25